'use strict'

export const BREAKPOINTS = {
  screenL: 1920,
  screenM: 1680,
  screenS: 1440,
  tabletL: 1366,
  tabletM: 1280,
  tabletS: 1024,
  mobileL: 768,
  mobileM: 560,
  mobileS: 480,
  mobileXS: 375
}

export const DEVICES = {
  screenXXL: [2560, 1440],
  screenXL: [2240, 1260],
  screenL: [1920, 1024],
  screenM: [1680, 1024],
  screenS: [1440, 720],
  tabletL: [1366, 926],
  tabletM: [1280, 768],
  tabletS: [1024, 768],
  mobileL: [768, 375],
  mobileM: [560, 768],
  mobileS: [480, 768],
  mobileXS: [375, 768]
}
